import { useCallback, useEffect, useState } from 'react';
import { fetchUserGeolocations } from './actions';
import { IUserGeolocation, UserGeolocationsReturnType } from './types';

// Istoric locații cetățean (GET api/users/:id/geolocations), paginat server-side.
// Fallback stabil ca identitate pentru `data` neîncărcat — un `[]` nou la fiecare
// randare re-declanșează efectele consumatorilor cu dependență pe `data`.
const EMPTY_LIST: IUserGeolocation[] = [];

export function useUserGeolocations(
	userId: number | string | undefined = undefined,
	defaultPageSize = 10
): UserGeolocationsReturnType {
	const [data, setData] = useState<IUserGeolocation[] | null>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [page, setPage] = useState<number>(0);
	const [items, setItems] = useState<number>(defaultPageSize);
	const [totalPages, setTotalPages] = useState<number>(1);
	const [totalItems, setTotalItems] = useState<number>(0);

	const handleResponse = (totalPagesParam: number, totalItemsParam: number): void => {
		setTotalPages(totalPagesParam);
		setTotalItems(totalItemsParam);
	};

	const getGeolocations = useCallback(
		async (id: number | string, pageParam: number, itemsParam: number) => {
			try {
				setLoading(true);
				const response = await fetchUserGeolocations(
					id,
					pageParam,
					itemsParam,
					handleResponse
				);
				setData(response);
			} catch {
				// eroarea ajunge în toast + jurnal prin pipeline-ul global de erori
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	useEffect(() => {
		if (userId === undefined) {
			setLoading(false);
			return;
		}
		getGeolocations(userId, page, items);
	}, [userId, page, items, getGeolocations]);

	return {
		data: data || EMPTY_LIST,
		loading,
		page,
		items,
		setPage,
		setItems,
		totalPages,
		totalItems,
		refetch: () => {
			if (userId !== undefined) getGeolocations(userId, page, items);
		}
	};
}
